import React from "react";
import { atom, useRecoilState } from "recoil";
import styled from "styled-components";

interface SPointTabText {
  isActive: boolean;
}

interface SPointTabColumn {
  isDisabled?: boolean;
}

export interface STabBar {
  tab: number;
}

export const pointTabState = atom<number>({
  key: "pointTabState",
  default: 0,
});

export default function PointTab() {
  const [tab, setTab] = useRecoilState(pointTabState);

  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>
          포인트 적립/사용
        </PointTabText>

        <PointTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>
          포인트 등록 내역
        </PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

export const PointTabContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 28px;
`;

export const PointTabColumn = styled.div<SPointTabColumn>`
  position: relative;
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
`;

export const PointTabText = styled.span<SPointTabText>`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: ${({ isActive, theme }) =>
    isActive ? theme.color.textColor : theme.color.gray400};
`;

export const PointTabBar = styled.div<STabBar>`
  position: absolute;
  width: ${({ tab }) => (tab === 0 ? 122 : 124)}px;
  height: 3px;
  background-color: ${({ theme }) => theme.color.gray900};
  bottom: -8px;
  left: ${({ tab }) => (tab === 0 ? 0 : 138)}px;

  transition: left 0.2s ease;
`;
